package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.extensions.convertToDataClass
import com.eladfinish.bible.contest.extensions.formatString
import com.eladfinish.bible.contest.screens.openQuestions.model.QuestionItem
import com.eladfinish.bible.contest.screens.pairMatching.model.PairsTopicItem
import com.eladfinish.bible.contest.utils.RegexUtils.UNDERSCORES

class TurnPairsToOpenQuestionsUseCase {

    operator fun invoke(data: String): List<QuestionItem> {
        val items = mutableListOf<QuestionItem>()
        val pairsTopicItems = data.convertToDataClass<List<PairsTopicItem>>()

        for ((_, _, keyTitle, valueTitle, _, _, pairsArray) in pairsTopicItems) {
            if (keyTitle.contains(Constants.SERIAL_NUMBER)) continue

            val valueToKeys = LinkedHashMap<String, ArrayList<String>>()

            for ((keyItem, valueItem) in pairsArray) {
                items.add(buildQuestion(keyTitle, valueTitle, keyItem, valueItem, inverse = false))

                valueToKeys.getOrPut(valueItem) { ArrayList() }.add(keyItem)
            }

            for ((valueItem, keys) in valueToKeys) {
                items.add(
                    buildQuestion(
                        keyTitle,
                        valueTitle,
                        keyItem = keys.joinToString(separator = ", "),
                        valueItem = valueItem,
                        inverse = true,
                    )
                )
            }
        }
        return items
    }

    private fun buildQuestion(
        keyTitle: String,
        valueTitle: String,
        keyItem: String,
        valueItem: String,
        inverse: Boolean,
    ): QuestionItem {
        val question = buildQuestionText(keyTitle, valueTitle, keyItem, valueItem, inverse)
        return QuestionItem(
            question = question,
            answer = if (inverse) keyItem else valueItem,
            author = "",
        )
    }

    private fun buildQuestionText(
        keyTitle: String,
        valueTitle: String,
        keyItem: String,
        valueItem: String,
        inverse: Boolean,
    ): String = if (inverse) {
        if (valueTitle.contains("עלה למלוכה בשנת")) {
            val formattedValueTitle = valueTitle.replace(
                regex = "_+ ל_+".toRegex(),
                replacement = "%s",
            )
            "$keyTitle:  ?\n${formattedValueTitle.formatString(valueItem)}"
        } else {
            "$keyTitle:  ?\n$valueTitle: $valueItem"
        }
    } else {
        if (keyTitle.contains("עַל־שְׁלֹשָׁה פִּשְׁעֵי")) {
            val formattedKeyTitle = keyTitle.replace(
                regex = UNDERSCORES.toRegex(),
                replacement = "*%s*",
            )
            "${formattedKeyTitle.formatString(keyItem)}\n$valueTitle:  ?"
        } else {
            "$keyTitle: $keyItem\n$valueTitle:  ?"
        }
    }
}
